import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "set"
}
const _hoisted_2 = { class: "board" }
const _hoisted_3 = ["data-player"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 28 28",
  width: "28px",
  height: "28px"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", { d: "M28 27H0V0l8.2 11.3L14 0l5.8 11.3L28 0v27Z" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "announcement" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "badge" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 28 28",
    width: "28px",
    height: "28px"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M28 27H0V0l8.2 11.3L14 0l5.8 11.3L28 0v27Z" })
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", { href: "/" }, "New game", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["echec-game", _ctx.game.winner === undefined ? `player${_ctx.game.currentPlayer + 1}-playing` : '']),
    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clickSomewhere && _ctx.clickSomewhere(...args)), ["self"]))
  }, [
    (_ctx.game.winner === undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "reserves",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickSomewhere && _ctx.clickSomewhere(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.game.reserve, (reserve, i) => {
              return (_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(`reserve reserve${i + 1}`),
                key: `reserve-${i}`
              }, _toDisplayString(reserve), 3))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.game.map, (row, rowIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row",
                key: `row-${rowIndex}`
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (square, columnIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["square", {
              selected: _ctx.selectedPawn && _ctx.selectedPawn[0] === columnIndex && _ctx.selectedPawn[1] === rowIndex,
              empty: square === 0,
              fortress: square > 1
            }]),
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clickSomewhere && _ctx.clickSomewhere(...args)), ["self"])),
                    key: `row-${columnIndex}`,
                    "data-player": square > 1 ? square - 1 : ''
                  }, [
                    (_ctx.selectedPawn && _ctx.movingOptions.findIndex(o => o[0] === columnIndex && o[1] === rowIndex) >= 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass(["moving-option", [`player${_ctx.game.board[rowIndex][columnIndex] + 1}`]]),
                          onClick: ($event: any) => (_ctx.movePawn(_ctx.selectedPawn, [columnIndex, rowIndex]))
                        }, null, 10, _hoisted_4))
                      : (_ctx.game.board[rowIndex][columnIndex] >= 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: _normalizeClass(["pawn", [`player${_ctx.game.board[rowIndex][columnIndex] + 1}`, _ctx.game.currentPlayer !== _ctx.game.board[rowIndex][columnIndex] ? 'disabled' : '']]),
                            onClick: ($event: any) => (_ctx.game.currentPlayer !== _ctx.game.board[rowIndex][columnIndex] ? _ctx.clickSomewhere() : _ctx.selectPawn([columnIndex, rowIndex]))
                          }, null, 10, _hoisted_5))
                        : (
                !_ctx.selectedPawn &&
                _ctx.game.initialBoard[rowIndex][columnIndex] === _ctx.game.currentPlayer &&
                _ctx.game.reserve[_ctx.game.currentPlayer] > 0
              )
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: _normalizeClass(["placing-option", [`player${_ctx.game.board[rowIndex][columnIndex] + 1}`]]),
                              onClick: ($event: any) => (_ctx.placePawn([columnIndex, rowIndex]))
                            }, null, 10, _hoisted_6))
                          : (square > 1)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
                            : _createCommentVNode("", true)
                  ], 10, _hoisted_3))
                }), 128))
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["winner", `winner-${_ctx.game.winner + 1}`])
        }, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("p", null, "Player " + _toDisplayString(_ctx.game.winner + 1) + " won the game!", 1)
          ]),
          _hoisted_12
        ], 2))
  ], 2))
}